function getLeadId() {
  const params = new URLSearchParams(window.location.search);
  return params.get('lead_id');
}

export default getLeadId;
